import { render, staticRenderFns } from "./SalesmanEvents.vue?vue&type=template&id=41af8947"
import script from "./SalesmanEvents.vue?vue&type=script&lang=js"
export * from "./SalesmanEvents.vue?vue&type=script&lang=js"
import style0 from "./SalesmanEvents.vue?vue&type=style&index=0&id=41af8947&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports